module.exports = __webpack_public_path__ + "img/dial5.490a2410.png";